module.exports = "/images/my-week-list.svg?245fda172b27bf936b88860757aaa957";